import React from 'react'
import {connect} from 'react-redux'
import styles from './CreatedSegments.scss'
import cardStyles from 'common/SearchableCard/SearchableCard.scss'
import {Loadable} from 'common/Loadable'
import {IntroWidget} from 'common/IntroWidget'
import {SearchableCard} from 'common/SearchableCard'
import {SegmentListItem} from 'common/ListItems'
import * as favoritesActions from 'lib/api/favorites'
import * as segmentsActions from 'lib/api/segments'
import _ from 'lodash'
import {DEFAULT_PER_PAGE} from 'lib/loadAllPages'
import {CTA} from 'common/styleguide/CTA'

class _CreatedSegments extends React.PureComponent {
  state = {
    keywords: '',
    limit: DEFAULT_PER_PAGE
  }

  favoriteForSegment = (segment) => (
    this.props.favorites.get('favorites').find(f => f.itemId === segment.id)
  )

  loadMore = () => {
    this.setState((state) => ({limit: state.limit + DEFAULT_PER_PAGE}))
  }

  render () {
    const {keywords, limit} = this.state
    const {segments, dispatchPin, dispatchUnpin} = this.props

    const createdSegments = segments
      .get('createdSegments')
      .map(segmentId => segments.getIn(['segments', segmentId]))
    const matches = keywords
      ? createdSegments.filter(({title}) => title.toLowerCase().includes(keywords.toLowerCase()))
      : createdSegments
    const toShow = matches.slice(0, limit)

    return (
      <div className={styles.CreatedSegments}>
        <SearchableCard
          keywords={keywords}
          onChange={e => this.setState({keywords: e.target.value, limit: DEFAULT_PER_PAGE})}
          resultsCount={matches.count()}
          resultsLength={toShow.count()}>
          {toShow.map(segment =>
            <SegmentListItem
              key={segment.slug}
              segment={segment}
              pin={dispatchPin}
              unpin={dispatchUnpin}
              pinnable
              pinned={this.favoriteForSegment(segment) && this.favoriteForSegment(segment).createdAt} />)}
          {createdSegments.count() === 0 && !keywords &&
            <IntroWidget large i='md-podium' link={<a href='https://ridewithgps.com/help/segments#create' target='_blank'>Learn About Creating Segments</a>}>
              You have no created segments
            </IntroWidget>}
          {toShow.count() === 0 && keywords.length > 0 &&
            <IntroWidget large i='md-podium'>
              No segments matched your search
            </IntroWidget>}
          {matches.count() > toShow.count() &&
            <div className={cardStyles.resultsFooter}>
              <CTA inline secondary margins={false} onClick={() => this.loadMore()}>
                Load more
              </CTA>
              <div style={{ paddingTop: '20px' }}>
                <span className={cardStyles.footerText}>Showing 1 - {toShow.count()} of {matches.count()} results</span>
              </div>
            </div>}
          {matches.count() === toShow.count() &&
            toShow.count() > DEFAULT_PER_PAGE &&
            <div className={cardStyles.resultsFooter}>
              <span className={cardStyles.footerText}>No more items to display</span>
            </div>}
        </SearchableCard>
      </div>
    )
  }
}

const loadInitialResources = _.memoize(({currentUser, loadPins, loadAllCreatedSegments}) => {
  const loadCurrentUserFavorites = () => loadPins(currentUser.id)

  const loadCurrentUserCreatedSegments = () => loadAllCreatedSegments(currentUser.id)

  const loadAll = Promise.all([
    loadCurrentUserFavorites(),
    loadCurrentUserCreatedSegments()
  ])

  return loadAll.then(
    ([favorites, segments]) => ({
      favorites,
      segments
    })
  )
})

const LoadableCreatedSegments = (props) => (
  <Loadable
    {...props}
    flashDelay={0}
    component={_CreatedSegments}
    loadingText='Loading your created segments'
    resourceLoaded={() => loadInitialResources(props)} />
)

const mapStateToProps = state => ({
  currentUser: state.currentUser,
  favorites: state.favorites,
  segments: state.segments
})

const mapDispatchToProps = (dispatch, _) => ({
  loadPins: (userId) => dispatch(favoritesActions.loadUserFavorites(userId, {object_types: JSON.stringify(['Segment'])})),
  loadAllCreatedSegments: (userId) => dispatch(segmentsActions.loadAllUserCreatedSegments(userId)),
  dispatchPin: (id) => dispatch(favoritesActions.pin('segment', id)),
  dispatchUnpin: (id) => dispatch(favoritesActions.unpin('segment', id))
})

export const CreatedSegments = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableCreatedSegments)
